
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/menu-list",
      function () {
        return require("private-next-pages/material-ui/api/menu-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/menu-list"])
      });
    }
  